import { useState } from 'react';
import { Link, Outlet } from 'react-router-dom';

const navLinks = [
  { label: 'Features', href: '/#features' },
  { label: 'Pricing', href: '/#pricing' },
];

export default function PublicLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {/* ─── Navbar ─────────────────────────────────────────────────────── */}
      <header
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 100,
          backdropFilter: 'blur(14px)',
          WebkitBackdropFilter: 'blur(14px)',
          background: 'oklch(13.5% 0.005 265 / .75)',
          borderBottom: '1px solid var(--line)',
        }}
      >
        <div className="wrap">
          <nav className="top">
            <Link className="logo" to="/">
              <img src="/logo.png" alt="Kavrenix" className="logo-mark" style={{ objectFit: 'contain' }} />
              Kavrenix
            </Link>

            <span style={{ flex: 1 }} />

            {/* Desktop nav links */}
            <div className="nav-desktop" style={{ display: 'flex', alignItems: 'center', gap: 28 }}>
              {navLinks.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  style={{
                    fontSize: '13.5px',
                    color: 'var(--fg-2)',
                    textDecoration: 'none',
                    transition: 'color .15s ease',
                  }}
                >
                  {item.label}
                </a>
              ))}

              <Link
                to="/login"
                className="link"
                style={{
                  fontSize: '13.5px',
                  color: 'var(--fg-2)',
                  textDecoration: 'none',
                  transition: 'color .15s ease',
                }}
              >
                Sign in
              </Link>

              <Link to="/register" className="btn btn-primary">
                Start free
              </Link>
            </div>

            {/* Mobile hamburger */}
            <button
              type="button"
              className="theme-tog"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="Toggle navigation menu"
              style={{ display: 'none' }}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </nav>
        </div>
      </header>

      {/* ─── Mobile Menu ────────────────────────────────────────────────── */}
      {mobileOpen && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 99,
            background: 'var(--overlay-bg)',
            backdropFilter: 'blur(6px)',
          }}
          onClick={() => setMobileOpen(false)}
        >
          <div
            style={{
              position: 'absolute',
              top: 0,
              right: 0,
              width: 280,
              height: '100%',
              background: 'var(--bg-1)',
              borderLeft: '1px solid var(--line)',
              padding: 24,
              display: 'flex',
              flexDirection: 'column',
              gap: 8,
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              onClick={() => setMobileOpen(false)}
              style={{
                all: 'unset',
                cursor: 'pointer',
                alignSelf: 'flex-end',
                padding: 8,
                color: 'var(--fg-2)',
              }}
              aria-label="Close menu"
            >
              ✕
            </button>
            {navLinks.map((item) => (
              <a
                key={item.label}
                href={item.href}
                onClick={() => setMobileOpen(false)}
                style={{
                  padding: '10px 12px',
                  fontSize: 14,
                  color: 'var(--fg-1)',
                  textDecoration: 'none',
                  borderRadius: 8,
                }}
              >
                {item.label}
              </a>
            ))}
            <Link
              to="/login"
              onClick={() => setMobileOpen(false)}
              style={{
                padding: '10px 12px',
                fontSize: 14,
                color: 'var(--fg-1)',
                textDecoration: 'none',
                borderRadius: 8,
              }}
            >
              Sign in
            </Link>
            <Link
              to="/register"
              onClick={() => setMobileOpen(false)}
              className="btn btn-primary"
              style={{ marginTop: 8 }}
            >
              Start free
            </Link>
          </div>
        </div>
      )}

      {/* ─── Page Content ───────────────────────────────────────────────── */}
      <main style={{ flexGrow: 1 }}>
        <Outlet />
      </main>

      {/* ─── Footer ─────────────────────────────────────────────────────── */}
      <footer className="site-footer">
        <div className="wrap">
          <div className="row">
            <Link className="logo" to="/">
              <img src="/logo.png" alt="Kavrenix" className="logo-mark" style={{ objectFit: 'contain' }} />
              Kavrenix
            </Link>
            <span style={{ flex: 1 }} />
            <a href="/#features">Features</a>
            <a href="/#pricing">Pricing</a>
            <a href="#">Status</a>
            <a href="#">Security</a>
            <a href="#">Privacy</a>
            <a href="#">Terms</a>
            <span>© {new Date().getFullYear()} Kavrenix</span>
          </div>
        </div>
      </footer>
    </div>
  );
}
